(function () {
  'use strict';

  function jsonFetch(url, options) {
    return fetch(url, Object.assign({
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
    }, options || {})).then(function (r) {
      return r.json().then(function (body) {
        if (!r.ok) {
          var err = new Error((body && (body.message || body.description)) || ('HTTP ' + r.status));
          err.payload = body;
          throw err;
        }
        return body;
      });
    });
  }

  function dispatch(cart, source) {
    document.dispatchEvent(new CustomEvent('cart:change', { detail: { cart: cart, source: source || 'api' } }));
  }

  window.AlkyraCart = {
    get: function () {
      return jsonFetch('/cart.js');
    },

    add: function (id, quantity, properties) {
      var body = { id: id, quantity: quantity || 1 };
      if (properties) body.properties = properties;
      return jsonFetch('/cart/add.js', { method: 'POST', body: JSON.stringify(body) });
    },

    change: function (line, quantity) {
      var body = { quantity: quantity };
      if (line !== null && line !== undefined) body.line = line;
      return jsonFetch('/cart/change.js', { method: 'POST', body: JSON.stringify(body) });
    },

    changeByKey: function (key, quantity) {
      return jsonFetch('/cart/change.js', { method: 'POST', body: JSON.stringify({ id: key, quantity: quantity }) });
    },

    clear: function () {
      return jsonFetch('/cart/clear.js', { method: 'POST' });
    },

    updateAttributes: function (attributes) {
      return jsonFetch('/cart/update.js', { method: 'POST', body: JSON.stringify({ attributes: attributes }) });
    },

    refresh: function (source) {
      return this.get().then(function (cart) { dispatch(cart, source); return cart; });
    },

    notify: function (source) {
      return this.refresh(source);
    }
  };

  document.addEventListener('DOMContentLoaded', initGlobalScripts);

  function initGlobalScripts() {
    var revealEls = document.querySelectorAll('.reveal');
    if (revealEls.length > 0 && 'IntersectionObserver' in window) {
      var revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      revealEls.forEach(function (el) { revealObserver.observe(el); });
    } else {
      revealEls.forEach(function (el) { el.classList.add('visible'); });
    }

    document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
      anchor.addEventListener('click', function (e) {
        var target = document.querySelector(anchor.getAttribute('href'));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          var mobileMenu = document.getElementById('mobile-menu');
          var hamburger = document.getElementById('hamburger');
          if (mobileMenu && mobileMenu.classList.contains('open')) {
            mobileMenu.classList.remove('open');
            if (hamburger) hamburger.classList.remove('open');
            document.body.style.overflow = '';
          }
        }
      });
    });

    var hamburger = document.getElementById('hamburger');
    var mobileMenu = document.getElementById('mobile-menu');

    if (hamburger && mobileMenu) {
      hamburger.addEventListener('click', function () {
        var isOpen = mobileMenu.classList.toggle('open');
        hamburger.classList.toggle('open', isOpen);
        hamburger.setAttribute('aria-expanded', String(isOpen));
        mobileMenu.setAttribute('aria-hidden', String(!isOpen));
        document.body.style.overflow = isOpen ? 'hidden' : '';
      });

      mobileMenu.querySelectorAll('.mobile-menu__link:not(.mobile-menu__disclosure-summary)').forEach(function (link) {
        link.addEventListener('click', function () {
          mobileMenu.classList.remove('open');
          hamburger.classList.remove('open');
          hamburger.setAttribute('aria-expanded', 'false');
          mobileMenu.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
        });
      });
    }

    initHeaderCartBadge();
  }

  function initHeaderCartBadge() {
    var badge = document.querySelector('[data-cart-badge]');
    if (!badge) return;
    document.addEventListener('cart:change', function (event) {
      var count = event.detail && event.detail.cart ? event.detail.cart.item_count : 0;
      badge.textContent = String(count);
      if (count > 0) {
        badge.removeAttribute('hidden');
        badge.classList.add('is-pulsing');
        setTimeout(function () { badge.classList.remove('is-pulsing'); }, 600);
      } else {
        badge.setAttribute('hidden', '');
      }
    });
  }
})();